// extracted by mini-css-extract-plugin
module.exports = {"container":"Brand_container__3QmZL","center":"Brand_center__2fvBb","body":"Brand_body__22CmV"};